import { render } from "./ServicioExternoList.vue?vue&type=template&id=97e32414&scoped=true"
import script from "./ServicioExternoList.vue?vue&type=script&lang=js"
export * from "./ServicioExternoList.vue?vue&type=script&lang=js"

import "./ServicioExternoList.vue?vue&type=style&index=0&id=97e32414&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e32414"]])

export default __exports__